import * as React from 'react';
const MenuClose = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 30 20"
		fill="none"
		{...props}
	>
		<path
			fill="#fff"
			d="M0 0h16.667v3.333H0V0Zm0 16.667h16.667V20H0v-3.333Zm0-8.334h20v3.334H0V8.333Zm21.667-6.666L19.3 3.983 25.233 10 19.3 16.017l2.367 2.316L30 10l-8.333-8.333Z"
		/>
	</svg>
);
export default MenuClose;
